import { API } from "../../api";

// const BASE_URL = "/cooperatives/fines";
// const BASE_URL_CAT = "/cooperatives/fine-categories";

const BASE_URL = "/cooperatives/settings/fines";
const BASE_URL_CAT = "/cooperatives/settings/fine-categories";

export const fineSettingsExtendedApi = API.injectEndpoints({
  endpoints: (builder) => ({
    getFines: builder.query({
      query: () => `${BASE_URL}?guard=staff`,
      transformResponse: (responseData) =>
        responseData?.data?.company_fines || responseData?.data || responseData,
      providesTags: ["Fines"],
    }),
    getFineCategories: builder.query({
      query: () => `${BASE_URL_CAT}?guard=staff`,
      transformResponse: (responseData) => responseData?.data || responseData,
    }),
    getFineById: builder.query({
      query: (fineId) => `${BASE_URL}/${fineId}/view?guard=staff`,
      transformResponse: (responseData) => responseData?.data || responseData,
      providesTags: (result, error, id) => [{ type: "Fines", id }],
    }),
    createFine: builder.mutation({
      query: (body) => ({
        url: `${BASE_URL}/add?guard=staff`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["Fines"],
    }),
    updateFine: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `${BASE_URL}/${id}/edit?guard=staff`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result, error, { id }) => [
        "Fines",
        { type: "Fines", id },
      ],
    }),
    toggleFineStatus: builder.mutation({
      query: (fineId) => ({
        url: `${BASE_URL}/${fineId}/toggle-active?guard=staff`,
        method: "PATCH",
      }),
      invalidatesTags: ["Fines"],
    }),
  }),
});

export const {
  useGetFinesQuery,
  useGetFineCategoriesQuery,
  useGetFineByIdQuery,
  useCreateFineMutation,
  useUpdateFineMutation,
  useToggleFineStatusMutation,
} = fineSettingsExtendedApi;
